import React from 'react';

import Arrow from './Arrow.jsx';
import { Block } from './Block.jsx';
import { BuilderPagerControls, EmptyContentPlaceholder } from '../layout/Builder.jsx';
import Layout from './Layout.jsx';
import Utilities from './Utilities.jsx';

const AnimationType = {
    slide: '0',
    fadeIn: '1',
    fadeOut: '2'
}

const defaultItemsPerSlide = 1;
function CarouselComponent(props) {
    const [itemSpacing, setItemSpacing] = React.useState({ "unit": "px", "value": "40" });
    const [itemsPerSlide, setItemsPerSlide] = React.useState(defaultItemsPerSlide);

    // Reloading items based on external changes
    const reload = () => {
        let items = defaultItemsPerSlide;
        if (window && window.outerWidth > 768 && props.blockConfig && props.blockConfig.block && props.blockConfig.block.items) {
            items = parseInt(props.blockConfig.block.items, 10);
        }
        setItemsPerSlide(items);
    }
    const [id, setId] = React.useState(undefined);
    React.useEffect(() => { setId(`carousel-${parseInt(Math.random() * new Date().getTime(), 10)}`) }, []);

    const getMobileStyle = () => {
        if (props.blockConfig.layout.heightMobile && props.blockConfig.layout.heightMobile.value && props.blockConfig.layout.heightMobile.value.length > 0) {
            let unit = props.blockConfig.layout.heightMobile.unit;
            if (props.useVH != true && unit == 'vh' && props.inLayout) {
                unit = '%';
            }
            return `height:${props.blockConfig.layout.heightMobile.value}${unit}!important;`;
        }
    }
    React.useEffect(() => {
        if (!id || props.builder) {
            return;
        }
        const style = getMobileStyle();
        if (style) {
            Utilities.addMobileStyle(id, style)
        }
    }, [id])
    React.useEffect(() => {
        window.addEventListener('resize', reload);
        return () => window.removeEventListener('resize', reload)
    }, [])
    React.useEffect(() => {
        reload();
        setCurrentIndex(0);
    }, [props.blockConfig.block.items, props.blockConfig.block.animation])
    React.useEffect(() => {
        setItemSpacing(props.blockConfig.block.itemSpacing);
    }, [props.blockConfig.block.itemSpacing.value]);

    // Block config
    let alignment, arrowOffset, containerStyle;
    let arrowsVisible = true;
    let animationDuration = '300';
    let animationType = '0';
    let _itemSpacing = { unit: 'px', value: 0 };
    let thumbnailTopSpacing = '50px';
    const arrowStyle = { pointerEvents: props.builder ? 'none' : undefined };
    let style = {};
    Utilities.copyObject(props.style, style);
    if (props.blockConfig) {
        if (props.blockConfig.block) {
            if (props.blockConfig.block.items != '1') {
                _itemSpacing = itemSpacing;
            }
            if (props.blockConfig.block.arrowOffset && props.blockConfig.block.arrowOffset.value && props.blockConfig.block.arrowOffset.value.length > 0) {
                arrowOffset = `${props.blockConfig.block.arrowOffset.value}${props.blockConfig.block.arrowOffset.unit}`;
            }
            if (props.blockConfig.block.arrowSize && props.blockConfig.block.arrowSize.value && props.blockConfig.block.arrowSize.value.length > 0) {
                arrowStyle.fontSize = `${props.blockConfig.block.arrowSize.value}${props.blockConfig.block.arrowSize.unit}`;
            }
            if (props.blockConfig.block.animationDuration && props.blockConfig.block.animationDuration.toString().length > 0) {
                animationDuration = props.blockConfig.block.animationDuration;
            }
            animationType = props.blockConfig.block.animation;
            arrowStyle.color = props.blockConfig.block.arrowColor;
            arrowsVisible = props.blockConfig.block.arrowsVisible != false;

            if (props.blockConfig.block.thumbnailTopSpacing && props.blockConfig.block.thumbnailTopSpacing.value && props.blockConfig.block.thumbnailTopSpacing.value.length > 0) {
                thumbnailTopSpacing = `${props.blockConfig.block.thumbnailTopSpacing.value}${props.blockConfig.block.thumbnailTopSpacing.unit}`;
            }
        }
        if (props.blockConfig.layout) {
            Block.mapStyleConfigProps(style, props.blockConfig.layout, (propName, propValue, propUnit) => {
                switch (propName) {
                    case 'alignment':
                        alignment = propValue;
                        return true;
                    case 'height':
                    case 'maxHeight':
                    case 'minHeight':
                        if (props.useVH != true && propValue && propValue.length > 0 && propUnit == 'vh' && props.inLayout) {
                            style[propName] = `${propValue}%`;
                            return true;
                        }
                        break;
                    case 'marginLeft':
                    case 'marginRight':
                        if (propValue) {
                            if (!containerStyle) {
                                containerStyle = {};
                            }
                            if (props.builder) {
                                containerStyle[propName.replace('margin', 'padding')] = `${propValue}${propUnit}`;
                            } else {
                                containerStyle[propName] = `${propValue}${propUnit}`;
                            }
                        }
                        return true;
                    case 'marginBottom':
                    case 'marginTop':
                        if (props.builder) {
                            // Margins applied to block container when in layout in builder context
                            return true;
                        }
                        if (propValue) {
                            if (!containerStyle) {
                                containerStyle = {};
                            }
                            containerStyle[propName] = `${propValue}${propUnit}`;
                        }
                        return true;
                    case 'maxWidth':
                    case 'minWidth':
                    case 'width':
                        if (propValue && propValue.length > 0 && propUnit == '%' && props.inLayout) {
                            style[propName] = `${propValue}%`;
                            return true;
                        }
                        break;
                    case 'heightMobile':
                        return true;
                }
            });
        }
        if (containerStyle) {
            containerStyle.maxWidth = style.maxWidth;
            containerStyle.minWidth = style.minWidth;
            containerStyle.width = style.width;

            style.maxWidth = undefined;
            style.minWidth = undefined;
            style.width = undefined;

            if (!props.inLayout && !containerStyle.marginLeft && !containerStyle.marginRight && !containerStyle.paddingLeft && !containerStyle.paddingRight) {
                containerStyle = Block.updateAlignment(containerStyle, alignment);
            }
        } else if (!props.inLayout) {
            style = Block.updateAlignment(style, alignment);
        }
    }

    if (containerStyle && (style.height || style.maxHeight || style.minHeight)) {
        if (!props.inLayout || !props.builder) {
            containerStyle.height = style.height;
            containerStyle.maxHeight = style.maxHeight;
            containerStyle.minHeight = style.minHeight;
        } else {
            containerStyle.height = '100%';
        }
        style.height = '100%';
        style.maxHeight = undefined;
        style.minHeight = undefined;
    }

    const [mobileStyle, setMobileStyle] = React.useState(undefined);
    if (props.builder) {
        if (props.inLayout) {
            style.maxWidth = undefined;
            style.minWidth = undefined;
            style.width = undefined;
        }
        if (!props.blockConfig.layout.heightMobile) {
            props.blockConfig.layout.heightMobile = { 'unit': 'px' };
        }
        React.useEffect(() => {
            if (!id) {
                return;
            }
            const style = getMobileStyle();
            if (style) {
                setMobileStyle(Utilities.createMobileStyle(id, style));
            }
        }, [id, props.blockConfig.layout.heightMobile.value]);
    }
    let mobileStyleContainer;
    if (mobileStyle != undefined) {
        mobileStyleContainer = <style dangerouslySetInnerHTML={{ __html: mobileStyle }} />
    }

    // Paging
    const [currentIndex, setCurrentIndex] = React.useState(0);
    const [transitionProps, setTransitionProps] = React.useState({ type: AnimationType.slide });
    const [swap, setSwap] = React.useState(false);
    const animateToPage = (_index, direction) => {
        if (!props.data) {
            return;
        }
        let index = _index;
        setSwap(false);

        switch (animationType) {
            case AnimationType.fadeIn:
            case AnimationType.fadeOut:
                if (transitionProps.fadeOut) {
                    // Already fading
                    break;
                }
                const count = props.data.length;
                if (index < 0) {
                    index += count;
                } else {
                    index = index % count;
                }
                setTransitionProps({
                    fadeOut: true,
                    nextIndex: index,
                    paging: true,
                    type: animationType,
                    onTransitionEnd: () => {
                        setCurrentIndex(index);

                        // Allow current index update to re-render before removing the animation placeholder
                        setTimeout(() => setTransitionProps({ fadeOut: false }), 100);
                    }
                });
                break;
            default:
                if (props.blockConfig && props.blockConfig.block && props.blockConfig.block.pagingType == '1') {
                    index = currentIndex + (direction == 'prev' ? -1 : 1);
                }
                const _transitionProps = {};
                Utilities.copyObject(transitionProps, _transitionProps)
                _transitionProps.paging = true;
                const slideIndexDelta = Math.abs(index - currentIndex);
                if (slideIndexDelta > 1) {
                    _transitionProps.animationDuration = animationDuration * slideIndexDelta;
                } else {
                    _transitionProps.animationDuration = undefined;
                }
                setTransitionProps(_transitionProps);
                setCurrentIndex(index);
                break;
        }
    }
    const handlePageChange = React.useCallback((direction) => {
        if (!props.data) {
            return;
        }
        const count = props.data.length;
        if (currentIndex < -itemsPerSlide || currentIndex > count) {
            // Beyond the edges of the carousel => Prevent any index changes while swapping happens
            return;
        }
        // Animate the change to the new slide index
        let index = currentIndex + (direction == 'prev' ? -1 : 1) * itemsPerSlide;
        animateToPage(index, direction);
    }, [currentIndex, itemsPerSlide, animationType, transitionProps.fadeOut, props.data]);
    const handleSwap = () => {
        if (!props.data) {
            return;
        }
        const count = props.data.length;
        if (currentIndex < 0) {
            // At beginning's edge => Move to end of carousel with no animation
            setSwap(true);
            setCurrentIndex(count + currentIndex);
        } else if (currentIndex >= count) {
            // At end's edge => Move to beginning of carousel with no animation
            setSwap(true);
            setCurrentIndex(currentIndex - count);
        }
        const _transitionProps = {};
        Utilities.copyObject(transitionProps, _transitionProps)
        _transitionProps.animationDuration = undefined;
        _transitionProps.paging = false;
        setTransitionProps(_transitionProps);
    }

    // Autoplay
    const [autoplayTimeout, setAutoplayTimeout] = React.useState(undefined);
    const [timeoutHandle, setTimeoutHandle] = React.useState(undefined);
    const stopAutoplay = () => {
        if (timeoutHandle) {
            clearTimeout(timeoutHandle);
        }
    }
    React.useEffect(() => {
        if (props.builder || !autoplayTimeout) {
            return;
        }
        stopAutoplay();
        if (transitionProps.paging) {
            return;
        }
        const _handle = setTimeout(handlePageChange, autoplayTimeout);
        setTimeoutHandle(_handle);
    }, [autoplayTimeout, handlePageChange, transitionProps.paging]);

    React.useEffect(() => {
        if (props.blockConfig.block.autoplayTimeout != undefined && props.blockConfig.block.autoplayTimeout.toString().length > 0) {
            const timeout = parseInt(props.blockConfig.block.autoplayTimeout, 10);
            if (!isNaN(timeout) && timeout != 0) {
                setAutoplayTimeout(timeout);
            }
        }
        return stopAutoplay;
    }, [props.blockConfig.block.autoplayTimeout]);

    // Empty Carousel
    if (!props.data || !props.data.length) {
        if (props.builder) {
            const message = props.emptyMessage || "This slideshow doesn't have any slides yet, but you can add them under the Slides section.";
            return (
                <React.Fragment>
                    <BuilderPagerControls disabled={true} inLayout={props.inLayout} onBlockMove={props.onBlockMove} />
                    <EmptyContentPlaceholder style={style}>{message}</EmptyContentPlaceholder>
                </React.Fragment>
            );
        }
        return null;
    }
    let className = 'carousel';
    if (props.className) {
        className += ` ${props.className}`;
    }
    const SlideComponent = props.slideComponent || Pony;

    // Static Carousel (data < items per slide)
    if (props.data && props.data.length <= itemsPerSlide) {
        // Not enough slides to fill more than one page => Render as static/non-scrolling slider
        let content = [];
        for (let i = 0; i < itemsPerSlide; i++) {
            let slideStyle;
            const columnSpacing = Layout.columnSpacing(i, itemsPerSlide, _itemSpacing);
            if (columnSpacing) {
                slideStyle = { paddingLeft: columnSpacing.left, paddingRight: columnSpacing.right };
            }
            if (i < props.data.length) {
                content.push(
                    <StaticSlideComponent
                        {...props}
                        key={i}
                        component={SlideComponent}
                        data={props.data[i]}
                        index={i}
                        itemsPerSlide={itemsPerSlide}
                        style={slideStyle} />
                );
            } else {
                // Add a padding slide to simulate the items per slide
                content.push(<StaticSlideComponent key={i} index={i} itemsPerSlide={itemsPerSlide} style={slideStyle} />);
            }
        }
        className += ' carousel--static';
        // if (props.slidePreviewComponent && thumbnailTopSpacing) {
        //     style.paddingBottom = style.paddingBottom ? `calc(${style.paddingBottom}${thumbnailTopSpacing})` : thumbnailTopSpacing;
        // }
        content = (
            <div className={className} id={containerStyle ? undefined : id} style={style}>
                {mobileStyleContainer}
                {content}
            </div>
        )
        if (containerStyle) {
            content = <div className="carousel__container" id={id} style={containerStyle}>{content}</div>
        }
        return (
            <>
                {
                    props.builder &&
                    <BuilderPagerControls disabled={true} inLayout={props.inLayout} onBlockMove={props.onBlockMove} />
                }
                {props.title}
                {content}
            </>
        );
    }
    if (props.onStyleAdjustment) {
        props.onStyleAdjustment(style, { offset: arrowOffset, style: arrowStyle });
    }
    let slideItemSpacing, wrapperStyle;
    if (itemsPerSlide > 1) {
        // Add item spacing to the slide
        slideItemSpacing = `${itemSpacing.value}${itemSpacing.unit}`;

        // Adjust the container width so it appears inline with sibling block components
        wrapperStyle = { height: '100%', position: 'relative', width: `calc(100% + ${slideItemSpacing})` };
    }

    // Content
    const slidePreviews = [];
    let content = props.data.map((d, i) => {
        if (props.slidePreviewComponent) {
            slidePreviews.push(<props.slidePreviewComponent key={i} data={d} onClick={() => !props.builder && animateToPage(i)} />);
        }
        return <SlideComponent key={i} {...props} arrowOffset={arrowOffset || 0} data={d} index={i} itemSpacing={slideItemSpacing} />
    });
    let extraContent, leadingSlides, trailingSlides;
    const count = props.data.length;
    const slideContainerStyle = {};
    switch (animationType) {
        case AnimationType.fadeIn: {
            trailingSlides = [];
            for (let i = 0; i < itemsPerSlide - (count % itemsPerSlide); i++) {
                const index = i % count;
                trailingSlides.push(<SlideComponent className="trailing" key={i + count} {...props} data={props.data[index]} itemSpacing={slideItemSpacing} />);
            }
            const extraContentStyle = { height: '100%', transition: `opacity ${animationDuration}ms linear`, width: '100%' };
            if (transitionProps.fadeOut) {
                slideContainerStyle.opacity = '0';
                slideContainerStyle.transition = `opacity ${animationDuration}ms linear`;

                extraContent = [];
                for (let i = 0; i < itemsPerSlide; i++) {
                    let index = transitionProps.nextIndex;
                    if (index < 0) {
                        index += itemsPerSlide;
                    }
                    index = (index + i) % count
                    let slideStyle;
                    const columnSpacing = Layout.columnSpacing(i, itemsPerSlide, _itemSpacing);
                    if (columnSpacing) {
                        slideStyle = { paddingLeft: columnSpacing.left, paddingRight: columnSpacing.right };
                    }
                    extraContent.push(<SlideComponent className="fade__placeholder" key={`next-${i}`} {...props} data={props.data[index]} style={slideStyle} />)
                }
                extraContentStyle.opacity = '1';
            }
            extraContent = (
                <div className="carousel--absolute carousel--fade__placeholder" style={extraContentStyle}>
                    <div className="carousel__slides">
                        {extraContent}
                    </div>
                </div>
            );

            // Get the current page offset: adjust the index for the slides per page
            slideContainerStyle.left = `${-100 * (currentIndex / itemsPerSlide)}%`;

            // Calculate the width of the carousel: (slide size % per page) * (total slide count, including duplicates)
            slideContainerStyle.width = `calc(${(100 / itemsPerSlide) * (count + trailingSlides.length)}%)`
            break;
        }
        case AnimationType.fadeOut: {
            trailingSlides = [];
            for (let i = 0; i < itemsPerSlide - (count % itemsPerSlide); i++) {
                const index = i % count;
                trailingSlides.push(<SlideComponent className="trailing" key={i + count} {...props} data={props.data[index]} itemSpacing={slideItemSpacing} />);
            }
            slideContainerStyle.transition = `opacity ${animationDuration / 2}ms`;
            if (transitionProps.fadeOut) {
                slideContainerStyle.opacity = '0';
                slideContainerStyle.transition += ' ease-in';
            } else {
                slideContainerStyle.opacity = '1';
                slideContainerStyle.transition += ' ease-in-out';
            }

            // Get the current page offset: adjust the index for the slides per page
            slideContainerStyle.left = `${-100 * (currentIndex / itemsPerSlide)}%`;

            // Calculate the width of the carousel: (slide size % per page) * (total slide count, including duplicates)
            slideContainerStyle.width = `calc(${(100 / itemsPerSlide) * (count + trailingSlides.length)}%)`
            break;
        }
        default: {
            let _animationDuration = '0';
            if (!swap) {
                _animationDuration = transitionProps.animationDuration || animationDuration;
            }
            slideContainerStyle.transition = `left ${swap ? '0' : _animationDuration}ms 0ms`;

            // Duplicate the last page of the carousel before the first page
            leadingSlides = [];
            for (let i = count - itemsPerSlide; i < count; i++) {
                leadingSlides.push(<SlideComponent className="leading" key={i - itemsPerSlide} {...props} data={props.data[i]} itemSpacing={slideItemSpacing} />);
            }

            // Duplicate enough slides such that a single, non-duplicated item can be displayed on the last page with duplicated slides to fill the page,
            // and then another page is available for paging
            trailingSlides = [];
            for (let i = 0; i < itemsPerSlide * 2 - 1; i++) {
                const index = i % count;
                trailingSlides.push(<SlideComponent className="trailing" key={i + count} {...props} data={props.data[index]} itemSpacing={slideItemSpacing} />);
            }

            // Get the current page offset: adjust the index for the slides per page, then offset beyond the duplicated last page (+ 1)
            const currentPage = currentIndex / itemsPerSlide + 1;
            slideContainerStyle.left = `${-100 * currentPage}%`;

            // Calculate the width of the carousel: (slide size % per page) * (total slide count, including duplicates)
            slideContainerStyle.width = `calc(${(100 / itemsPerSlide) * (count + leadingSlides.length + trailingSlides.length)}%)`
            break;
        }
    }
    const renderPreviews = slidePreviews.length > 1;
    if (renderPreviews) {
        slideContainerStyle.paddingBottom = `calc(50px + ${thumbnailTopSpacing})`;
    }
    content = (
        <div className={className} id={containerStyle ? undefined : id} style={style}>
            <div className="carousel__wrapper">
                <div style={wrapperStyle}>
                    <div className="carousel__slides"
                        style={slideContainerStyle}
                        onTransitionEnd={transitionProps.onTransitionEnd || handleSwap}>
                        {leadingSlides}
                        {content}
                        {trailingSlides}
                    </div>
                </div>
                {extraContent}
            </div>
            {
                renderPreviews &&
                <div className="slider__dots--full__width">
                    {slidePreviews}
                </div>
            }
            {
                arrowsVisible != false &&
                <>
                    <Arrow direction="prev" offset={arrowOffset} style={arrowStyle} onClick={handlePageChange} />
                    <Arrow direction="next" offset={arrowOffset} style={arrowStyle} onClick={handlePageChange} />
                </>
            }
        </div>
    )
    if (containerStyle) {
        content = <div className="carousel__container" id={id} style={containerStyle}>{content}</div>
    }
    return (
        <React.Fragment>
            {mobileStyleContainer}
            {
                props.builder &&
                <BuilderPagerControls inLayout={props.inLayout} onBlockMove={props.onBlockMove} onPageChange={handlePageChange} />
            }
            {props.title}
            {content}
        </React.Fragment>
    );
}
const Carousel = { Component: CarouselComponent };

function StaticSlideComponent(props) {
    let className = `col--${(12 / props.itemsPerSlide).toString().replace('.', '_')} col--slide`;
    if (!props.component) {
        return <div className={className} style={props.style} />;
    }
    return (
        <div className={className}>
            <props.component {...props} />
        </div>
    );
}

function Pony() { return <div>Yee-haw!</div> }

export { AnimationType, Carousel };
// export default { AnimationType, Component: Carousel }